<!-- CONTAINER PRINCIPAL -->
<fieldset class="q-fieldset">
  <legend>Affectation des questionnaires</legend>

  <div *ngIf="infosQuestionnaires.LstQuestionnaires && infosQuestionnaires.LstQuestionnaires.length > 0" class="table-responsive">
    <!-- TABLEAU -->
    <table class="table table-bordered">
      <!-- HEAD -->
      <thead>
        <tr class="noBTop">
          <th class="noBLeft">&nbsp;</th>
          <th class="noBLeft">Type de questionnaire</th>
          <th class="noBLeft noBRight">Date d'activation</th>
        </tr>
      </thead>
      <!-- BODY -->
      <tbody>
        <!-- COULEUR && SELECT -->
        <tr *ngFor="let questionnaire of infosQuestionnaires.LstQuestionnaires">
          <td class="colorSize align-middle" [ngClass]="questionnaire.DateIsActivated ? 'q-main' : 'q-warning'">&nbsp;</td>
          <td class="align-middle">
            <label class="col-12 pt-2 mb-0" for="inputQuest">{{questionnaire.Labelle}}</label>
            <select (change)="UpdateProp($event.target)" class="q-main-select w-75 heightSelect ml-2 mb-2" name="inputQuest">
              <option [value]="undefined" [attr.type]="questionnaire.TypeQuestionnaire"> - - - - - </option>
              <option *ngFor="let prop of questionnaire.LstInfosProps" [selected]="prop.IsSelected" [attr.type]="questionnaire.TypeQuestionnaire" [value]="prop.Ident">{{prop.Titre}}</option>
            </select>
          </td>

          <!-- GESTION DES DATES -->
          <ng-container *ngIf="!questionnaire.DateIsActivated; else displayDate">
            <td class="noBLeft align-middle">
              <p class="rounded-button q-light-grey mr-3 w-75 transformY"><i class="far fa-clock"></i>&nbsp;- - - - -</p>
            </td>
          </ng-container>
          <ng-template #displayDate>
            <td class="noBLeft align-middle">
              <label class="col-12 mb-0 invisible"></label>
              <q-bo-property-inline *ngIf="questionnaire.DateActivation" class="mr-3" button-custom-class="{{questionnaire.ClassDatePick}}" type="DATE" (close)="UpdateDate($event,questionnaire.TypeQuestionnaire)" [property]="questionnaire.DateActivation"></q-bo-property-inline>
            </td>
          </ng-template>
        </tr>
      </tbody>
    </table>

  </div>
</fieldset>
